import React from 'react';
import { Text } from '@chakra-ui/react';
import { CustomerRole } from 'src/contexts/AuthContext';

type UserRoleBadgeProps = {
  role: CustomerRole;
};

const roleLabels: Record<CustomerRole, string> = {
  [CustomerRole.ADMIN]: 'Admin',
  [CustomerRole.USER]: 'User',
};

export const UserRoleBadge: React.FC<UserRoleBadgeProps> = ({ role }) => {
  return (
    <Text fontSize="sm" color="gray.600">
      {roleLabels[role]}
    </Text>
  );
};
